// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"b1e7689f","655":"b1e7689f","947":"b1e7689f"}[chunkId] + ".chunk.css";
};